import { createContext } from 'react'
import type { DailyCall } from '@daily-co/daily-js'

export interface VisioContextType {
  shouldStartCall: boolean
  kioskId: number | null
  storeId: number | null
  includeVideo: boolean
  isCallInProgress: boolean
  callObject: DailyCall | null
  setCallObject: (callObject: DailyCall | null) => void
  askCall: (kioskId: number, storeId: number, includeVideo: boolean) => void
  startCall: () => void
  endCall: () => void
}

export const VisioContext = createContext<VisioContextType>({
  askCall: () => {},
  callObject: null,
  endCall: () => {},
  includeVideo: false,
  isCallInProgress: false,
  kioskId: null,

  setCallObject: () => {},

  shouldStartCall: false,

  startCall: () => {},

  storeId: null,
})
